import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { forwardRef } from 'react';
import { useGeneratedId } from '../../../utils/index.js';
import { useDescriptionWarning } from './utils.js';
import { Container, Label, InputContainer, Adornment, Input, Description } from './styled.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var TextInput = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  var autoId = useGeneratedId('textinput');
  var _props$appearance = props.appearance,
    appearance = _props$appearance === void 0 ? 'outline' : _props$appearance,
    _props$id = props.id,
    id = _props$id === void 0 ? autoId : _props$id,
    label = props.label,
    ariaDescribedBy = props['aria-describedby'],
    description = props.description,
    _props$stretch = props.stretch,
    stretch = _props$stretch === void 0 ? false : _props$stretch,
    _props$invalid = props.invalid,
    invalid = _props$invalid === void 0 ? false : _props$invalid,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    adornmentLeft = props.adornmentLeft,
    adornmentRight = props.adornmentRight,
    defaultValue = props.defaultValue,
    value = props.value,
    onChange = props.onChange,
    restProps = __rest(props, ["appearance", "id", "label", 'aria-describedby', "description", "stretch", "invalid", "disabled", "adornmentLeft", "adornmentRight", "defaultValue", "value", "onChange"]);
  var handleChange = function handleChange(event) {
    if (onChange) {
      onChange(event);
    }
  };
  var describedBy = ariaDescribedBy || description && id + "-description";
  useDescriptionWarning({
    ariaDescribedBy: ariaDescribedBy,
    description: description
  });
  var inputProps = Object.assign(Object.assign({}, restProps), {
    ref: forwardedRef,
    id: id,
    disabled: disabled,
    'aria-describedby': describedBy,
    defaultValue: defaultValue,
    value: value,
    onChange: handleChange
  });
  return /*#__PURE__*/jsxs(Container, {
    $stretch: stretch,
    children: [label && /*#__PURE__*/jsx(Label, {
      htmlFor: id,
      $invalid: invalid,
      children: label
    }), /*#__PURE__*/jsxs(InputContainer, {
      $invalid: invalid,
      $appearance: appearance,
      children: [adornmentLeft && /*#__PURE__*/jsx(Adornment, {
        children: adornmentLeft
      }), /*#__PURE__*/jsx(Input, _extends({}, inputProps)), adornmentRight && /*#__PURE__*/jsx(Adornment, {
        children: adornmentRight
      })]
    }), description && /*#__PURE__*/jsx(Description, {
      $invalid: invalid,
      id: describedBy,
      $disabled: disabled,
      children: description
    })]
  });
});

export { TextInput };
